<form [formGroup]="mainForm">
  <h1 mat-dialog-title>{{ 'EMPLOYEE_GROUP_ADD_DIALOG.TITLE' | translate }}</h1>
  <div mat-dialog-content>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'EMPLOYEE_GROUP_ADD_DIALOG.NAME_LABEL' | translate }}</mat-label>
      <input matInput formControlName="name" cdkFocusInitial>
    </mat-form-field>

  </div>
  <div mat-dialog-actions class="flex-h flex-end">
    <button mat-flat-button color="primary" (click)="ok()" type="submit">{{ 'GENERAL.OK' | translate }}</button>
    <button mat-flat-button color="accent" [mat-dialog-close]>{{ 'GENERAL.CANCEL' | translate }}</button>
  </div>
</form>
